/**
 * Génère un ID unique basé sur un timestamp et un nombre aléatoire
 * @param {string} prefix - Préfixe optionnel pour l'ID
 * @returns {string} ID unique généré
 */
export const generateId = (prefix = '') => {
  const timestamp = Date.now().toString(36);
  const randomPart = Math.random().toString(36).substr(2, 5);
  return prefix
    ? `${prefix}_${timestamp}_${randomPart}`
    : `${timestamp}_${randomPart}`;
};

/**
 * Génère un ID unique pour les fonctions
 * @returns {string} ID unique pour fonction
 */
export const generateFunctionId = () => {
  return generateId('func');
};

/**
 * Génère un ID unique pour les arguments
 * @returns {string} ID unique pour argument
 */
export const generateArgumentId = () => {
  return generateId('arg');
};
